import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { DataProvider } from './contexts/DataContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { LoginPage } from './pages/LoginPage';
import { ProtectedRoute } from './components/ProtectedRoute';
import { DashboardLayout } from './layouts/DashboardLayout';
import { CashierWorkplacePage } from './features/cashier/CashierWorkplacePage';

// Reports
import {
  ProductRatingPage,
  AverageCheckPage,
  SalesAnalysisPage,
  StockBalancePage,
  CashBalancePage,
} from './features/reports';

// Operations
import {
  ReceiptPage,
  SalePage,
  WriteOffPage,
  ReturnFromCustomerPage,
} from './features/operations';

// References
import {
  BanksPage,
  BankAccountsPage,
  WarehousesPage,
  ProductCategoriesPage,
  CountriesPage,
  GekdCodesPage,
  TnvedCodesPage,
  UnitsPage,
  ContractorsPage,
  ContractsPage,
  ProductsPage,
} from './features/references';

import './App.css';

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <LanguageProvider>
          <DataProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              {/* Cashier */}
              <Route path="cashier-workplace" element={<CashierWorkplacePage />} />

              {/* Reports */}
              <Route path="reports/product-rating" element={<ProductRatingPage />} />
              <Route path="reports/average-check" element={<AverageCheckPage />} />
              <Route path="reports/sales-analysis" element={<SalesAnalysisPage />} />
              <Route path="reports/stock-balance" element={<StockBalancePage />} />
              <Route path="reports/cash-balance" element={<CashBalancePage />} />

              {/* Operations */}
              <Route path="operations/receipt" element={<ReceiptPage />} />
              <Route path="operations/sale" element={<SalePage />} />
              <Route path="operations/write-off" element={<WriteOffPage />} />
              <Route path="operations/return-from-customer" element={<ReturnFromCustomerPage />} />

              {/* References */}
              <Route path="references/banks" element={<BanksPage />} />
              <Route path="references/bank-accounts" element={<BankAccountsPage />} />
              <Route path="references/warehouses" element={<WarehousesPage />} />
              <Route path="references/product-categories" element={<ProductCategoriesPage />} />
              <Route path="references/countries" element={<CountriesPage />} />
              <Route path="references/gekd-codes" element={<GekdCodesPage />} />
              <Route path="references/tnved-codes" element={<TnvedCodesPage />} />
              <Route path="references/units" element={<UnitsPage />} />
              <Route path="references/contractors" element={<ContractorsPage />} />
              <Route path="references/contracts" element={<ContractsPage />} />
              <Route path="references/products" element={<ProductsPage />} />

              {/* Default route */}
              <Route index element={<Navigate to="cashier-workplace" replace />} />
            </Route>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          </DataProvider>
        </LanguageProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;